import { Component, Input, Output, Inject, PLATFORM_ID, ElementRef, Renderer2, ChangeDetectorRef, ViewChild, ChangeDetectionStrategy, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Observable } from 'rxjs';
import { PartialObserver } from 'rxjs/Observer';
import { Subscription } from 'rxjs/Subscription'
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { EventInteraction } from 'angular-engine/engine/service/dynamic/event.interaction.service';
import { UIStateEngine } from 'angular-engine/engine/service/ui/ui.state.engine';
import { APP_SETTINGS } from 'angular-engine/modules/ng-express-engine/tokens';
import { ScrollingHelperService } from 'angular-engine/engine/service/ui/scrolling/scrolling.helper.service';
import { DataSourceComponent } from "./data-source.component";

@Component({
    selector: 'interactive-component',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InteractiveComponent extends DataSourceComponent {
    @Input() item: any;
    @Input() isActive: boolean;
    @Input() slug: string;
    @Input() focusedItemIndex: number;
    @Input() verticalScrollingEnabled: boolean = false;
    @Input() interactionSelect: boolean;
    @Input() interactionBack: boolean;
    @Input() virtualPageSize: number;
    @ViewChild('scroller') scrollElement: ElementRef;
    @Input() activeSlug: string;
    @Input() inScopeItems: Array<any> = [];
    @Input() isPaged: boolean = false;
    @Output() onItemFocused: EventEmitter<any> = new EventEmitter<any>();
    //protected filterObj: any;
    //protected filterControl: boolean;
    //protected filterValue: string = "";
    protected isServer: boolean;
    protected last_page = 1;
    protected subscriptions: Array<Subscription> = [];
    protected scrollListener: Subscription;
    protected keys = [];
    protected monitoredPropsMap = {
        isActive: 'isActive',
        focusedItemIndex: 'selectedItem',
        offsetScrollX: 'offsetScrollX',
        offsetScrollY: 'offsetScrollY'
    };
    protected focusedItem: any;
    protected maxPerRow: number;
    protected numberOfRows = 1;
    //use this to set traversal mode
    protected interactionMode: any;
    protected KeyCode: any;
    protected KeyConfig: any;
    protected TraversalModes: any;    
    protected awaitRefocus: boolean;
    offsetScrollY = 0.0;
    offsetScrollX = 0.0;

    public get element(): any {
        return this.elem;
    }

    constructor(
        protected router: Router,
        protected eventInteractions: EventInteraction,
        protected uiStateEngine: UIStateEngine,
        protected elem: ElementRef,
        protected ref: ChangeDetectorRef,
        protected route: ActivatedRoute,
        protected coreEffects: CoreEffects,
        @Inject(PLATFORM_ID) protected platformId: string,
        @Inject(APP_SETTINGS) protected settings: any,
        protected renderer: Renderer2,
        protected scrollHelper: ScrollingHelperService) {
        super(ref)
        this.isServer = isPlatformServer(this.platformId);
        this.KeyCode = this.settings.KeyCode;
        this.KeyConfig = this.settings.KeyConfig;
        this.TraversalModes = this.settings.TraversalModes;
        this.scrollHelper.renderer = renderer;
    }

    ngOnInit() {
        this.isPaged = (this.router.url.indexOf("/search") > -1) ? true : false;
        this.uiStateEngine.setDefaultSelectedItem(this);
        this.uiStateEngine.setSupportedKeys(this);
        this.uiStateEngine.restoreScrollPositionIfAvailable(this);

        if (this.virtualPageSize) {
            this.uiStateEngine.adjustInScopeItems(this, this.focusedItemIndex);
        }
        if (this.isActive) {
            this.uiStateEngine.registerInteractiveHandler(this);
        }
    }

    ngAfterViewInit() {
        this.uiStateEngine.setScrollingOptions(this);
    }

    //#region component focus/activation logic

    ngOnChanges(changes: any) {
        if (this.keys.length > 0) {
            if (changes.isActive !== undefined && changes.isActive.currentValue !== changes.isActive.previousValue) {
                this.changeHandlerState(changes.isActive.currentValue);
            }        
        }
    }

    changeHandlerState(state) {
        if (state) {
            this.uiStateEngine.registerInteractiveHandler(this);
        }
        else {
            this.uiStateEngine.deregisterHandler(this);
        }
        this.activeStateChanged(state);
    }

    activeStateChanged(state) {
        //override if needed
        if (state) {
            if (!this.interactionMode) {
                if (this.onItemFocused.observers.length > 0) {
                    this.onItemFocused.next(this.elem);
                }
            }
        }
        else if (this.interactionMode) {
            this.awaitRefocus = true;
        }
    }

    //override if custom focusing needed
    protected focusedItemChanged(targetElem) {
        this.uiStateEngine.focusedItemChanged(this, targetElem);
        if (!this.isServer && this.isPaged ){
            const spot = Math.abs(parseInt(this.settings['SEARCH_CATEGORY_LIMIT'])/2);
            this.uiStateEngine.addTheNextPage(this, spot);
        }
    }

    //#endregion

    //#region Scrolling logic

    //process horizontal-scrolling request
    protected scrollHorizontally(elem) {
        const xPosition = elem ? this.scrollHelper.requestHorizontalScrollPosition(elem) : 0
        this.offsetScrollX = xPosition;
        this.uiStateEngine.setDescendantProp(this.slug, 'offsetScrollX', this.offsetScrollX)
        this.scrollToOffset(xPosition, -1);
    }

    protected requestVerticalScroll(elem) {
        const yPosition = elem ? this.scrollHelper.requestVerticalScrollPosition(elem) : 0
        if (yPosition > 0 || this.offsetScrollY > 0) {
            this.offsetScrollY = yPosition;
            this.uiStateEngine.setDescendantProp(this.slug, 'offsetScrollY', this.offsetScrollY);
            this.scrollToOffset(-1, yPosition);
        }
    }

    protected scrollToOffset(xPosition, yPosition) {
        setTimeout(() => { window.dispatchEvent(new Event("scroll")) }, 300);
        this.ref.detectChanges()
    }

    //#endregion

    ngOnDestroy() {
        this.uiStateEngine.deregisterHandler(this);
        this.subscriptions.forEach(s => s.unsubscribe());
        this.removeScrollListener(true);
    }

    private removeScrollListener(destroy?: boolean) {
        if (this.scrollListener) {
            this.scrollListener.unsubscribe();
            if (destroy) {
                this.scrollListener = null;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-component/interactive.component.ts